/**
 * ProtectedRoute.js
 * Component for protecting routes that require authentication
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/api';
import { USER_ROLES } from '../../utils/constants';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  const isAdmin = authService.hasRole(USER_ROLES.ADMIN);
  
  if (!isAuthenticated || !isAdmin) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
